<template>
  <div>
    <div class="flex items-center">
      <h1 class="font-bold text-3xl">
        Jenjang Pendidikan
      </h1>
      <inertia-link
        class="btn-indigo my-4 ml-4"
        :href="route('jenjang_pendidikan.create')">
        <span>Create</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto w-full md:w-3/4">
      <table class="whitespace-nowrap w-full">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">
            Nama Jenjang Pendidikan
          </th>
          <th class="px-6 pt-6 pb-4">
            Deskripsi
          </th>
          <th class="px-6 pt-6 pb-4" colspan="2">
            Last Update
          </th>
        </tr>
        <tr
          v-for="jp in jenjangPendidikans.data"
          :key="jp.id"
          class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t whitespace-normal">
            <inertia-link
              class="px-6 py-4 flex items-center focus:text-indigo-500"
              :href="route('jenjang_pendidikan.edit', jp.id)">
              {{ jp.name }}
              <icon
                v-if="jp.deleted_at"
                name="trash"
                class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t whitespace-normal">
            <inertia-link
              class="px-6 py-4 flex items-center"
              :href="route('jenjang_pendidikan.edit', jp.id)"
              tabindex="-1">
              {{ jp.descriptions }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link
              class="px-6 py-4 flex items-center"
              :href="route('jenjang_pendidikan.edit', jp.id)"
              tabindex="-1">
              {{ jp.updated_at }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link
              class="px-4 flex items-center"
              :href="route('jenjang_pendidikan.edit', jp.id)"
              tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="jenjangPendidikans.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">
            No Jenjang Pendidikan found.
          </td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="jenjangPendidikans.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import { Link } from '@inertiajs/vue2'

export default {
  metaInfo: { title: 'Jenjang Pendidikan' },
  components: {
    Icon,
    Pagination,
    'inertia-link': Link,
  },
  layout: Layout,
  props: {
    jenjangPendidikans: Object,
  },
}
</script>
